import React from 'react';
export const Text = ({ value, className, style, onClick, }) => {
    return (React.createElement("div", { className: className, style: {
            whiteSpace: 'pre-line',
            ...style,
        }, onClick: onClick, onKeyDown: () => { }, role: "button", tabIndex: 0 }, value));
};
